import { apiService } from './apiService';

export const trailerService = {
  async getTrailers(params?: { externalTransportAccountUserId?: string; ownerType?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.externalTransportAccountUserId) queryParams.append('externalTransportAccountUserId', params.externalTransportAccountUserId);
    if (params?.ownerType) queryParams.append('ownerType', params.ownerType);
    const query = queryParams.toString();
    return apiService.get(`/trailers${query ? `?${query}` : ''}`);
  },
  async getTrailer(id: string | number) {
    return apiService.get(`/trailers/${id}`);
  },
  async createTrailer(data: any) {
    return apiService.post('/trailers', data);
  },
  async updateTrailer(id: string | number, data: any) {
    return apiService.put(`/trailers/${id}`, data);
  },
  async deleteTrailer(id: string | number) {
    return apiService.delete(`/trailers/${id}`);
  },
};
